import * as Yup from "yup";

import { LABLES, NAMES } from "./WebFormFieldsNames";

let {
    COMPANY_NAME,
    DATE_OF_INCORPORATION,
    CORPORATION_NUMBER,
    REGISTERED_OFFICE_ADDRESS,
    RECORD_ADDRESS,
    PLACES_OF_BUSINESS_ADDRESS,
    DIRECTOR_NAME,
    DIRECTOR_FULL_ADDRESS,
    DIRECTOR_TITLE,
    AS_OF_DATE,
    CONTACT_NUMBER,
    FAX,
    EMAIL,
    WEBSITE,
    APPOINTMENT_CALENDER_LINK,
    INCORPORATOR_NAME,
    FIRM_NAME,
    FULL_ADDRESS,
    BAR_STATE,
    PDF_TITLE,
    COUNTRY,
    STATE
} = LABLES;

const validationSchema = Yup.object().shape({
    [NAMES[PDF_TITLE]]: Yup.string().required("Pdf Title is required"),
    [NAMES[COUNTRY]]: Yup.string().required("Select Country"),
    [NAMES[STATE]]: Yup.string().required("Select State"),
    [NAMES[COMPANY_NAME]]: Yup.string().required("Company Name is required"),
    [NAMES[DATE_OF_INCORPORATION]]: Yup.date()
        .nullable() // Allows the date to be empty initially
        .required("Date of Incorporation is required")
        .max(new Date(), "Date of Incorporation cannot be in the future"),
    [NAMES[CORPORATION_NUMBER]]: Yup.number()
        .typeError("Corporation Number must be a number") // Error message if input is not a number
        .required("Corporation Number is required")
        .integer("Corporation Number must be an integer"),
    [NAMES[REGISTERED_OFFICE_ADDRESS]]: Yup.string().required(
        "Registered Office Address is required"
    ),
    [NAMES[RECORD_ADDRESS]]: Yup.string().required("Record Address is required"),
    [NAMES[PLACES_OF_BUSINESS_ADDRESS]]: Yup.string().required(
        "Places of Business Address is required"
    ),
    [NAMES[DIRECTOR_NAME]]: Yup.string().required("Director Name is required"),
    [NAMES[DIRECTOR_FULL_ADDRESS]]: Yup.string().required("Director Full Address is required"),
    [NAMES[DIRECTOR_TITLE]]: Yup.string().required("Director Title is required"),
    [NAMES[AS_OF_DATE]]: Yup.string().required("As of Date is required"),
    [NAMES[CONTACT_NUMBER]]: Yup.string().required("Contact Number is required"),
    [NAMES[FAX]]: Yup.string().required("Fax is required"),
    [NAMES[EMAIL]]: Yup.string().required("Email is required").email("Invalid email format"),
    [NAMES[WEBSITE]]: Yup.string()
        .required("Website is required")
        .matches(/^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+.*$/, "Invalid URL format"),
    [NAMES[APPOINTMENT_CALENDER_LINK]]: Yup.string().required(
        "Appointment Calendar Link is required"
    ),
    [NAMES[INCORPORATOR_NAME]]: Yup.string().required("Incorporator Name is required"),
    [NAMES[FIRM_NAME]]: Yup.string().required("Firm Name is required"),
    [NAMES[FULL_ADDRESS]]: Yup.string().required("Full Address is required"),
    [NAMES[BAR_STATE]]: Yup.string().required("Bar State/Zip Code is required")
});

export default validationSchema;
